import { Watchable } from "../_Utils/Watchable";

export type TServiceFeeProviderAttrs = {
    _id: string;
    name: string;
    csvRowsBelow: number;
    annotatedColumns: {
        clientname?: { annotation: string[] };
        company?: { annotation: string };
        reference?: { annotation: string };
        statementdate?: { annotation: string; dateFormat: string };
        revenuetype?: { annotation: string };
        fee?: { annotation: string };
        revenuegenerated?: { annotation: string };
        revenuepayable?: { annotation: string };
        gstgenerated?: { annotation: string };
        gstpayable?: { annotation: string };
        adviser?: { annotation: string };
        repcode?: { annotation: string };
    };
    adviserRefs: {
        user: string;
        ref: string;
    }[];
};

type ProviderEventMap = {
    ATTRIBUTES_UPDATED: TServiceFeeProviderAttrs;
    PROVIDER_DELETED: null;
};

class ProviderData extends Watchable<ProviderEventMap> {
    private cAttrs: TServiceFeeProviderAttrs;

    constructor(attrs: TServiceFeeProviderAttrs) {
        super();
        this.cAttrs = attrs;
        this.attrs = attrs;
    }

    triggerProviderDeleted() {
        this.trigger("PROVIDER_DELETED", null);
    }

    set attrs(atr: TServiceFeeProviderAttrs) {
        this.cAttrs = atr;

        this.trigger("ATTRIBUTES_UPDATED", atr);
    }

    get attrs() {
        return this.cAttrs;
    }
}

export class ServiceFeeProvider {
    public data: ProviderData;
    public readonly id: string;

    constructor(attributes: TServiceFeeProviderAttrs) {
        this.data = new ProviderData(attributes);
        this.id = attributes._id;
    }

    updateProvider(provider: ServiceFeeProvider) {
        this.updateProviderAttrs(provider.data.attrs);
        return this;
    }

    updateProviderAttrs(attrs: TServiceFeeProviderAttrs) {
        this.data.attrs = attrs;
        return this;
    }

    remove() {
        this.data.triggerProviderDeleted();
    }
}
